import { api } from "./api"

let storeInstance = null;

async function loadStore() {
  if (!storeInstance) {
    storeInstance = (await import('../services/store.js')).store
  }
  return storeInstance
}

export const environmentService = {
    async get() {
        try {
            console.log('[Environment Service] Fetching environment from: /environment');
            // Empty baseURL overrides the api instance's '/api/v1' prefix — /environment
            // sits at the root, not under the versioned API. Relative in every mode so
            // Vite's proxy handles it in development (see api.js for the full rationale).
            const res = await api.get('/environment', {
                baseURL: '',
                timeout: 10000, // 10 second timeout
                skipLoading: true,
            });
            console.log('[Environment Service] Received environment:', res.data);
            
            // Save to Redux store for other components to use
            const store = await loadStore();
            store.dispatch({ type: 'setEnvironment', payload: res.data });
            console.log('[Environment Service] Saved to Redux store');
            
            return res.data;
        } catch (error) {
            console.error('[Environment Service] Failed to fetch environment:', error.message);
            // Return a fallback to prevent infinite loading
            return {
                sliceId: '',
                customerId: null,
                impersonating: false
            };
        }
    }
}